import React, { useEffect } from "react";
import { useAccount } from "wagmi";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const AdminRoute = () => {
  const { address, isConnected, isConnecting } = useAccount();
  const location = useLocation();
  const adminAddress = process.env.REACT_APP_TG_ADDRESS?.toLowerCase();

  useEffect(() => {
    // Log pour déboguer
    console.log("AdminRoute - isConnected:", isConnected);
    console.log("AdminRoute - address:", address);
    console.log("AdminRoute - adminAddress:", adminAddress);
    console.log("AdminRoute - isConnecting:", isConnecting);
  }, [isConnected, address, adminAddress, isConnecting]);

  // Attendre que wagmi termine de vérifier la connexion
  if (isConnecting) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#00263a]">
        <div className="text-white text-xl">Vérification de l'accès...</div>
      </div>
    );
  }

  // Si l'utilisateur n'est pas connecté, rediriger vers la page d'accueil
  if (!isConnected || !address) {
    console.log("AdminRoute - Redirection: utilisateur non connecté");
    return <Navigate to="/" replace />;
  }

  // Vérifier que l'adresse admin est définie
  if (!adminAddress) {
    console.error("REACT_APP_TG_ADDRESS n'est pas défini dans .env");
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#00263a]">
        <div className="text-white text-xl">Erreur de configuration</div>
      </div>
    );
  }

  // Comparer les adresses en minuscules pour éviter les problèmes de casse
  const userAddressLower = address.toLowerCase();
  if (userAddressLower !== adminAddress) {
    console.log("AdminRoute - Redirection: adresse non autorisée");
    console.log("AdminRoute - Adresse utilisateur:", userAddressLower);
    console.log("AdminRoute - Adresse admin attendue:", adminAddress);
    return <Navigate to="/" replace />;
  }

  // Si l'adresse correspond, autoriser l'accès
  console.log("AdminRoute - Accès autorisé");
  return <Outlet />;
};

export default AdminRoute;

